import React from 'react';

import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

const NodePartnerTeaser = ({ entity, className }) => {
  const image = entity.getIn(['field_image', 0, 'styles', 'crop_3_4']);

  return (
    <article className="NodePartnerTeaser">
      <div className="NodePartnerTeaser__image">
        <Image
          lazyload
          includeWebP
          src={image}
        />
      </div>
    </article>
  );
};

export default NodePartnerTeaser;
